import 'ress';
import domContentLoaded from 'dom-content-loaded';
// import { throttle } from 'throttle-debounce';
import top from './top';
import voice from './voice';
import carousel from './carousel';
import togglemenu from './togglemenu';
import scrollAnimation from './scroll-animation';
import qAndA from './q-and-a';
import fixbutton from './fixbutton';
import '../scss/style.scss';

top();
voice();
carousel();
togglemenu();
scrollAnimation();
qAndA();
fixbutton();

domContentLoaded(() => {
	// 郵便番号の「-」の挿入
	$('.js-insert-hyphen').blur((e) => {
		const insertStr = (str, index, insert) => str.slice(0, index) + insert + str.slice(index, str.length);
		const input = e.currentTarget;
		const zip = input.value;
		if (zip.length > 6 && !zip.match('-')) {
			input.value = insertStr(zip, 3, '-');
		}
	});
});
